export default __webpack_public_path__ + "static/media/greenConsults.22c6ad7d.jpg";